export default {
  key: 'Eb',
  suffix: '7sus4',
  positions: [{
    frets: 'xx1324',
    fingers: '001324'
  }, {
    frets: 'x66644',
    fingers: '023411',
    barres: 4,
    capo: true
  }, {
    frets: '668696',
    fingers: '113141',
    barres: 6,
    capo: true
  }, {
    frets: 'bdbdbb',
    fingers: '131411',
    barres: 11,
    capo: true
  }]
};